import { cva } from 'class-variance-authority';

export const flagVariants = cva('relative inline-flex min-h-1 items-center rounded-sm px-1', {
  variants: {
    variant: {
      contrast: 'text-color-text-light bg-color-grey-dark',
      neutral: 'text-color-text-dark bg-color-grey-light',
      sale: 'text-color-sale-contrasttext bg-color-sale',
      secondary: 'text-color-secondary-contrasttext bg-color-secondary',
      sustainability: 'text-color-sustainability-contrasttext bg-color-sustainability',
    },
    size: {
      default: 'text-size-body-xs',
      large: 'text-size-body-base',
    },
  },
  defaultVariants: {
    variant: 'neutral',
    size: 'default',
  },
});
